define('app/filters/SegmentCompoundFilterView',['require','./CompoundFilterView','./SegmentCompactFieldFilterView','hbs!./SegmentCompoundFilterView.hbs'],function(require) {
	'use strict';

	var CompoundFilterView = require('./CompoundFilterView'),
		CompactFieldFilterView = require('./SegmentCompactFieldFilterView');

	var SegmentCompoundFilterView = CompoundFilterView.extend({
		compactFieldFilterView: CompactFieldFilterView,

		template: require('hbs!./SegmentCompoundFilterView.hbs')

	});

	return SegmentCompoundFilterView;

});

